import React from "react";
import Layout from "@/components/Layout";
import { ScrollFade, HeroStaggerText } from "@/lib/animations";

export default function ShippingPolicy() {
  return (
    <Layout>
      <section className="bg-[#163A2F] text-[#F8F6F0] grain relative pt-20 pb-16 md:pt-28 md:pb-20 overflow-hidden">
        <div className="relative z-10 max-w-[1440px] mx-auto px-6 md:px-12 lg:px-24">
          <div className="overline text-[#C9A227]">Legal</div>
          <HeroStaggerText
            text="Shipping Policy"
            className="mt-3 text-4xl md:text-6xl font-extralight tracking-tight"
          />
          <p className="mt-4 text-[#F8F6F0]/70 font-light text-sm tracking-wider">Last updated: 10 February 2026</p>
        </div>
      </section>

      <section className="bg-[#F8F6F0] py-16 md:py-20" data-testid="shipping-policy-page">
        <div className="max-w-3xl mx-auto px-6 md:px-10 text-[#163A2F] font-light leading-relaxed space-y-8">
          <ScrollFade>
            <p>
              We ship every Norbu jacket from our studio in New Delhi through trusted courier partners via Shiprocket. Here is what to expect.
            </p>
          </ScrollFade>

          <ScrollFade>
            <h2 className="text-xl md:text-2xl font-normal text-[#163A2F]">1. Where we ship</h2>
            <p className="mt-3 text-[#163A2F]/85">
              Currently we ship across India to all serviceable pincodes. International shipping is not available yet — write to us if you would like to place a special order.
            </p>
          </ScrollFade>

          <ScrollFade>
            <h2 className="text-xl md:text-2xl font-normal text-[#163A2F]">2. Processing time</h2>
            <p className="mt-3 text-[#163A2F]/85">
              Orders placed before 2:00 PM IST on a business day are usually dispatched within <strong>1–2 business days</strong>. Orders placed on Sundays or public holidays are dispatched the next working day.
            </p>
          </ScrollFade>

          <ScrollFade>
            <h2 className="text-xl md:text-2xl font-normal text-[#163A2F]">3. Delivery timelines</h2>
            <ul className="mt-3 list-disc pl-5 space-y-2 text-[#163A2F]/85">
              <li><strong>Metro cities</strong> (Delhi NCR, Mumbai, Bengaluru, Chennai, Hyderabad, Kolkata, Pune): 2–4 business days</li>
              <li><strong>Tier 2 cities &amp; towns:</strong> 4–6 business days</li>
              <li><strong>Remote &amp; North-East locations:</strong> 6–10 business days</li>
            </ul>
            <p className="mt-3 text-[#163A2F]/85">
              Timelines are indicative and may vary during sale periods, weather disruptions or courier delays beyond our control.
            </p>
          </ScrollFade>

          <ScrollFade>
            <h2 className="text-xl md:text-2xl font-normal text-[#163A2F]">4. Shipping charges</h2>
            <ul className="mt-3 list-disc pl-5 space-y-2 text-[#163A2F]/85">
              <li>Standard shipping is calculated at checkout based on your pincode and order weight (live Shiprocket rates).</li>
              <li>Free shipping is applied automatically on prepaid orders above <strong>₹2,999</strong>.</li>
              <li>Cash-on-Delivery (if available for your pincode) carries a flat ₹99 handling fee.</li>
            </ul>
          </ScrollFade>

          <ScrollFade>
            <h2 className="text-xl md:text-2xl font-normal text-[#163A2F]">5. Order tracking</h2>
            <p className="mt-3 text-[#163A2F]/85">
              Once your order is dispatched you will receive an email with the courier name and tracking link. You can also view the status at any time under <a href="/account" className="text-[#C9A227] underline">My Account → Orders</a>.
            </p>
          </ScrollFade>

          <ScrollFade>
            <h2 className="text-xl md:text-2xl font-normal text-[#163A2F]">6. Delivery attempts</h2>
            <p className="mt-3 text-[#163A2F]/85">
              Our courier partners make up to 3 delivery attempts. Please keep your phone reachable. If all attempts fail, the shipment is returned to our studio and we will contact you to reship (reshipping charges may apply).
            </p>
          </ScrollFade>

          <ScrollFade>
            <h2 className="text-xl md:text-2xl font-normal text-[#163A2F]">7. Incorrect address</h2>
            <p className="mt-3 text-[#163A2F]/85">
              Please double-check your shipping address at checkout. We cannot change the address once the order is dispatched. If the shipment is lost due to an incorrect address, Norbu Collection is not liable.
            </p>
          </ScrollFade>

          <ScrollFade>
            <h2 className="text-xl md:text-2xl font-normal text-[#163A2F]">8. Lost or damaged shipments</h2>
            <p className="mt-3 text-[#163A2F]/85">
              In the rare event a shipment is lost in transit, we will investigate with the courier and ship a replacement within 10 business days. For damage on arrival please refer to our <a href="/refund-policy" className="text-[#C9A227] underline">Refund &amp; Return Policy</a>.
            </p>
          </ScrollFade>

          <ScrollFade>
            <h2 className="text-xl md:text-2xl font-normal text-[#163A2F]">9. Contact</h2>
            <p className="mt-3 text-[#163A2F]/85">
              Email: <a href="mailto:support.norbucollection@gmail.com" className="text-[#C9A227] underline">support.norbucollection@gmail.com</a><br />
              WhatsApp / Phone: +91 95609 95329
            </p>
          </ScrollFade>
        </div>
      </section>
    </Layout>
  );
}
